// ----------------------------------------------------------------------------
// Snippet: Mini Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';
import 'snippets/cart-js/cart-js';
import 'snippets/card/card';

// Styles
import './_mini-cart.scss';

const MINI_CART_ITEM_DROPDOWN = '.mini-cart__item--dropdown';
const MINI_CART_LINK = '.mini-cart__header-link';
const ACTIVE_CLASS = 'highlighted-text';
const MINI_CART_BLUR_BACKGROUND = '.mini-cart__blur-background';
const MENU_ITEM_CART_BLUR_HOVER = '.mini-cart__item--dropdown--blur-hover';
const MENU_ITEM_CART_BUTTONS = '.button-collection .button';
const MENU_ITEM_CART_LINKS = '.card__link';


Shopify.miniCart = () => {

    const _config = {
        itemsContainerSelector : '.mini-cart__items-container',
        itemsListSelector      : '.mini-cart__items-list',
        miniCartFooterSelector : '.mini-cart__footer',
        miniCartCountSelector  : '.cart__count',
        shopifyAjaxCartURL     : '/cart.js',
    };

    const _init = () => {

        const itemsContainer     = document.querySelector(_config.itemsContainerSelector);
        const itemsList          = document.querySelector(_config.itemsListSelector);
        const cartCountContainer = document.querySelector(_config.miniCartCountSelector);

        if ( itemsContainer ) {
            // Update cart count and cart modal.
            fetch(_config.shopifyAjaxCartURL, {
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then((cart) => {
                    if (cart.items.length) {

                        if( !cartCountContainer.classList.contains(ACTIVE_CLASS) ) {
                            cartCountContainer.classList.add(ACTIVE_CLASS);
                        }
                    } else {    

                        if( cartCountContainer.classList.contains(ACTIVE_CLASS) ) {
                            cartCountContainer.classList.remove(ACTIVE_CLASS);
                        }
                    }

                    fetch(window.location.pathname + '?sections=mini-cart-dropdown--items-list')
                        .then(res => res.json())
                        .then((responseData) => {
                            itemsList.innerHTML = responseData['mini-cart-dropdown--items-list'];
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });

                    cartSubtotalUpdate(cart);
                });
        }
    };
    return {
        init: (params) => {
            // Configuration
            params = params || {};
            // Merging with defaults.
            Object.assign(_config, params);
            // Action
            _init();
        },
        getConfig: () => {
            return _config;
        }
    };
};

document.addEventListener('DOMContentLoaded', () => {

    const miniCartItemDropdown = document.querySelector(MINI_CART_ITEM_DROPDOWN);
    const miniCartLink = document.querySelector(MINI_CART_LINK);
    const miniCartBlurBackground = document.querySelector(MINI_CART_BLUR_BACKGROUND);
    const menuItemCartBlueHover = document.querySelector(MENU_ITEM_CART_BLUR_HOVER);
    const menuItemCartButtons = miniCartItemDropdown.querySelectorAll(MENU_ITEM_CART_BUTTONS);
    const menuItemCartLinks = miniCartItemDropdown.querySelectorAll(MENU_ITEM_CART_LINKS);

    if (menuItemCartBlueHover) {
        menuItemCartBlueHover.addEventListener('mouseover', () => {
            miniCartBlurBackground.style.display = 'block';
        });
    
        menuItemCartBlueHover.addEventListener('mouseout', () => {
            miniCartBlurBackground.style.display = 'none';
        });

        // Hide the blur background when clicking on buttons or links - Safari bug
        menuItemCartButtons?.forEach((button) => {
            button.addEventListener('click', function(event) {
                setTimeout(() => {
                    miniCartBlurBackground.style.display = 'none';
                }, 500);
            });
        });

        menuItemCartLinks?.forEach((link) => {
            link.addEventListener('click', function(event) {
                setTimeout(() => {
                    miniCartBlurBackground.style.display = 'none';
                }, 500);
            });
        });
    }

    miniCartItemDropdown.addEventListener('focusin', () => {
        if (!miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.add('js--is-open');
            if (menuItemCartBlueHover) {
                miniCartBlurBackground.style.display = 'block';
            }
            const tabIndexItems = miniCartItemDropdown.querySelectorAll('[tabindex="-1"]');
            tabIndexItems.forEach((tabIndexItem) => {
                tabIndexItem.setAttribute('tabindex', '0');
            });
        }
    });

    miniCartItemDropdown.addEventListener('focusout', () => {
        if (miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.remove('js--is-open');
            if (menuItemCartBlueHover) {
                miniCartBlurBackground.style.display = 'none';
            }
        }
    });

    miniCartItemDropdown.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartLink.focus();
            miniCartItemDropdown.classList.remove('js--is-open');
            if (menuItemCartBlueHover) {
                miniCartBlurBackground.style.display = 'none';
            }
        }
    });
});


